import { FetchAssertsService } from '@/packages/query-state/shared/services/FetchAssertsService';
import { type IQueryStateAppContext } from '@/packages/query-state/shared/types/appContext';

import {
  type IDeleteOfferFromComparisonResponse200,
  type IDeleteOfferFromComparisonResponse400,
  type TDeleteOfferFromComparisonRequest,
  type TDeleteOfferFromComparisonResponse_1,
  createDeleteOfferFromComparisonModel,
  fetchDeleteOfferFromComparison,
} from '@/repositories/generated/shared/offers-comparison/v1/delete-offer-from-comparison';

export function fetchDeleteComparisonService(
  applicationContext: IQueryStateAppContext,
  parameters: TDeleteOfferFromComparisonRequest,
): Promise<TDeleteOfferFromComparisonResponse_1> {
  const { httpApi, logger } = applicationContext;

  const fetchAssertsService = new FetchAssertsService(
    createDeleteOfferFromComparisonModel(parameters),
    '@/shared/store/serverSide/comparison/v1/delete-from-comparison/internal/fetchService.ts',
    logger,
  );

  return fetchDeleteOfferFromComparison<IDeleteOfferFromComparisonResponse200, IDeleteOfferFromComparisonResponse400>({
    httpApi,
    parameters,
  }).then(
    result => {
      const statusCode = result.statusCode;

      switch (result.statusCode) {
        case 200:
          return result.response;
        case 400:
          throw fetchAssertsService.assert400StatusCodeError(result);
        default:
          throw fetchAssertsService.assertUnknownStatusCodeError(statusCode);
      }
    },
    error => {
      throw fetchAssertsService.assertUnknownServerError(error);
    },
  );
}
